<div (click)="goToEvent(event.id)" class="tooltip">
  <div class="event">
    <div class="event__image">
      <div
        [ngStyle]="{
          background: 'url(' + getImage() + ')',
          height: '100%',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }"
      ></div>
    </div>

    <div class="event__info">
      <div class="event__name">
        {{ event.name }}
      </div>

      <div class="event__address">
        {{ getAddress() }}
      </div>
    </div>

    <div class="event__date">
      <div>
        <span class="month">{{ getMonth() }}</span>
        <span class="day">{{ getDay() }}</span>
        <span class="year">{{ getYear() }}</span>
      </div>
    </div>
  </div>
</div>
